import React from 'react';

import { formatUTCDateTime } from '../utils/scheduleUtils';

const getStatusText = (status) => {
  switch (status) {
    case 'completed':
      return 'Завершен';
    case 'cancelled':
      return 'Отменен';
    case 'scheduled':
      return 'Запланирован';
    default:
      return status;
  }
};

const getStatusClass = (status) => {
  switch (status) {
    case 'completed':
      return 'status-completed';
    case 'cancelled':
      return 'status-cancelled';
    case 'scheduled':
      return 'status-scheduled';
    default:
      return '';
  }
};

const LessonsList = ({ lessons, loading, userType }) => {
  const participantLabel = userType === 'teacher' ? 'Ученик' : 'Учитель';

  const getParticipantName = (lesson) => {
    if (userType === 'teacher') {
      return lesson.student_name || lesson.student_username;
    }
    return lesson.teacher_name || lesson.teacher_username;
  };

  if (loading) {
    return <div className="loading-message">Загрузка...</div>;
  }

  if (!lessons || lessons.length === 0) {
    return <div className="no-history">Уроки отсутствуют</div>;
  }

  return (
    <div className="history-table">
      <table className="history-table-content">
        <thead>
          <tr>
            <th>Дата начала</th>
            <th>Дата окончания</th>
            <th>{participantLabel}</th>
            <th>Длительность</th>
            <th>Статус</th>
          </tr>
        </thead>
        <tbody>
          {lessons.map((lesson) => (
            <tr key={lesson.id}>
              <td>{formatUTCDateTime(new Date(lesson.started_at))}</td>
              <td>
                {lesson.ended_at
                  ? formatUTCDateTime(new Date(lesson.ended_at))
                  : lesson.status === 'cancelled'
                    ? '—'
                    : 'В процессе'}
              </td>
              <td>{getParticipantName(lesson)}</td>
              <td>
                {lesson.duration_minutes
                  ? `${lesson.duration_minutes} мин.`
                  : lesson.status === 'cancelled'
                    ? '—'
                    : lesson.ended_at
                      ? '—'
                      : 'В процессе'}
              </td>
              <td>
                <span className={`history-status ${getStatusClass(lesson.status)}`}>
                  {getStatusText(lesson.status)}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LessonsList;
